module.exports = __webpack_public_path__ + "img/student_icon.929b72ef.png";